<ion-card>
  <ion-card-header>
    <ion-card-title>Szabályok és jogosultság</ion-card-title>
    <ion-card-subtitle>
      Az iratkezelési szabályok intézményenként állíthatók – a kiinduló készlet a
      Másolatkészítési Szabályzatból származik, de minden érték átírható, és saját
      szabály is felvehető.
    </ion-card-subtitle>
  </ion-card-header>

  <ion-card-content>
    <ion-segment [(ngModel)]="nezet" (ionChange)="nezetValt()" mode="ios">
      <ion-segment-button value="szabalyok"><ion-label>Iratkezelési szabályok</ion-label></ion-segment-button>
      <ion-segment-button value="jogosultsag"><ion-label>Jogosultság</ion-label></ion-segment-button>
      <ion-segment-button value="hivatalok"><ion-label>Hivatali kapu névsor</ion-label></ion-segment-button>
    </ion-segment>

    <!-- Hivatali kapus szervezetek hivatalos névsora -->
    <ng-container *ngIf="nezet === 'hivatalok'">
      <p style="margin:12px 0 4px;font-size:.86rem;line-height:1.55">
        A hivatali kapus szervezetek <b>hivatalos névsora</b> (NISZ). Ebből tölthető ki a
        partnertörzs <b>KRID</b> és <b>rövid név</b> mezője – küldéskor a címzettet ez a kettő
        azonosítja, és az elgépelt kód nem hibaüzenetet ad, hanem kézbesíthetetlen küldeményt.
        A kiszolgáló <b>éjszaka magától frissíti</b>; itt kézzel is elindítható.
      </p>

      <div class="ikt-fejsor" style="align-items:center;gap:14px;flex-wrap:wrap">
        <div>
          <div style="font-size:1.25rem;font-weight:700">{{ (hivAllapot?.db || 0) | number }}</div>
          <div style="font-size:.78rem;color:#64748b">aktív szervezet</div>
        </div>
        <div style="font-size:.82rem;color:#475569">
          Utolsó frissítés: <b>{{ hivIdo(hivAllapot?.utolso?.kesz || hivAllapot?.utolso?.indult) }}</b>
          · állapot: <b>{{ hivAllapotSzoveg(hivAllapot?.utolso?.allapot) }}</b>
          <span *ngIf="hivAllapot?.utolso?.inditotta"> · indította: {{ hivAllapot.utolso.inditotta }}</span>
          <div *ngIf="hivAllapot?.utolso?.megszunt" style="color:#b45309">
            {{ hivAllapot.utolso.megszunt }} szervezet kikerült a listából (megszűntnek jelölve)
          </div>
          <div *ngIf="hivAllapot?.utolso?.allapot === 'hiba'" style="color:var(--ion-color-danger)">
            {{ hivAllapot.utolso.hiba }}
          </div>
        </div>
        <span style="flex:1"></span>
        <ion-button size="small" fill="outline" [disabled]="hivFut" (click)="hivatalokFrissit()">
          <ion-spinner *ngIf="hivFut" name="dots"></ion-spinner>
          <span *ngIf="!hivFut"><ion-icon slot="start" name="cloud-download-outline"></ion-icon>Frissítés most</span>
        </ion-button>
      </div>

      <ion-note color="medium" style="display:block;margin:2px 0 10px;font-size:.76rem">
        A letöltés 10 MB körüli, ezért eltarthat pár percig; addig nyugodtan elnavigálhatsz.
        Ha a névsor nem változott, a frissítés nem ír az adatbázisba. Forrás:
        <code>{{ hivAllapot?.forras }}</code>
      </ion-note>

      <ion-input label="Keresés a névsorban" label-placement="stacked" [(ngModel)]="hivKeres"
                 (ionInput)="hivKeresValt()" placeholder="név, rövid név vagy KRID (legalább 2 karakter)"></ion-input>

      <div class="ikt-tabla-doboz" *ngIf="hivTalalatok.length" style="margin-top:8px">
        <table class="ikt-tabla">
          <thead><tr><th style="width:16%">Rövid név</th><th>Szervezet</th><th style="width:14%">KRID</th>
            <th style="width:16%">Interfész</th><th style="width:10%">Állapot</th></tr></thead>
          <tbody>
            <tr *ngFor="let h of hivTalalatok">
              <td><b>{{ h.rovidnev }}</b></td>
              <td>{{ h.nev }}</td>
              <td>{{ h.krid || '—' }}</td>
              <td>{{ h.interfesz || '—' }}</td>
              <td>{{ h.statusz }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <p *ngIf="hivKeres.length > 1 && !hivTalalatok.length" style="font-size:.84rem;color:#64748b">
        Nincs találat. Ha a névsor még üres, előbb futtasd le a frissítést.
      </p>
    </ng-container>

    <!-- Szabályok -->
    <ng-container *ngIf="nezet === 'szabalyok'">
      <div class="ikt-fejsor" style="margin-top:12px">
        <ion-button size="small" fill="outline" (click)="ujSzabalyForm = !ujSzabalyForm">
          <ion-icon slot="start" name="add-outline"></ion-icon>Saját szabály
        </ion-button>
      </div>

      <div class="ikt-fejsor" *ngIf="ujSzabalyForm">
        <ion-input label="Kulcs" label-placement="stacked" [(ngModel)]="ujSzabaly.kulcs"
                   placeholder="pl. selejtezes_jegyzokonyv"></ion-input>
        <ion-input label="Név" label-placement="stacked" [(ngModel)]="ujSzabaly.nev"></ion-input>
        <ion-input label="Érték" label-placement="stacked" [(ngModel)]="ujSzabaly.ertek"></ion-input>
        <ion-button size="small" (click)="ujSzabalyMent()">Mentés</ion-button>
      </div>

      <div *ngFor="let cs of csoportok" style="margin-top:16px">
        <h3>{{ csoportCim(cs) }}</h3>
        <div class="ikt-tabla-doboz">
          <table class="ikt-tabla">
            <thead><tr><th style="width:30%">Szabály</th><th style="width:28%">Érték</th><th>Magyarázat</th><th></th></tr></thead>
            <tbody>
              <tr *ngFor="let s of szabalyokCsoportban(cs)">
                <td>
                  {{ s.nev }}
                  <div style="font-size:.72rem;color:var(--ion-color-medium)">{{ s.kulcs }}</div>
                </td>
                <td>
                  <ion-checkbox *ngIf="s.tipus === 'igen_nem'" [checked]="s.ertek === '1'"
                                (ionChange)="s.ertek = $event.detail.checked ? '1' : '0'"></ion-checkbox>
                  <ion-input *ngIf="s.tipus !== 'igen_nem'" [(ngModel)]="s.ertek"
                             [type]="s.tipus === 'szam' ? 'number' : 'text'"></ion-input>
                </td>
                <td style="font-size:.78rem">
                  {{ s.leiras }}
                  <div *ngIf="s.forras" style="color:var(--ion-color-medium);font-style:italic">
                    Forrás: {{ s.forras }}
                  </div>
                </td>
                <td><ion-button size="small" fill="clear" (click)="ment(s)">Mentés</ion-button></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </ng-container>

    <!-- Jogosultság -->
    <ng-container *ngIf="nezet === 'jogosultsag'">
      <ion-note color="medium" style="display:block;margin:12px 0;font-size:.84rem">
        <b>Alapértelmezés:</b> minden admin minden irathoz hozzáfér. Rajta kívül az fér hozzá
        egy ügyirathoz, aki az ügyintézője – az alábbi lista ettől ELTÉRŐ, külön adott
        hozzáféréseket tartalmaz. Az „admin mindent lát” a Szabályok fülön kapcsolható ki.
      </ion-note>

      <div class="ikt-fejsor">
        <ion-input label="Felhasználó (adid)" label-placement="stacked" [(ngModel)]="ujJog.alany"></ion-input>
        <ion-select label="Hatókör" label-placement="stacked" interface="popover" [(ngModel)]="ujJog.hatokor">
          <ion-select-option value="konyv">iktatókönyv</ion-select-option>
          <ion-select-option value="ugyirat">egy ügyirat</ion-select-option>
        </ion-select>
        <ion-select *ngIf="ujJog.hatokor === 'konyv'" label="Melyik könyv" label-placement="stacked"
                    interface="popover" [(ngModel)]="ujJog.hatokor_id">
          <ion-select-option *ngFor="let k of konyvek" [value]="k.id">{{ k.nev }}</ion-select-option>
        </ion-select>
        <ion-input *ngIf="ujJog.hatokor === 'ugyirat'" label="Ügyirat azonosító" label-placement="stacked"
                   [(ngModel)]="ujJog.hatokor_id"></ion-input>
        <ion-select label="Szint" label-placement="stacked" interface="popover" [(ngModel)]="ujJog.szint">
          <ion-select-option value="olvas">olvasás</ion-select-option>
          <ion-select-option value="ir">írás</ion-select-option>
          <ion-select-option value="teljes">teljes</ion-select-option>
        </ion-select>
        <ion-button size="small" (click)="jogAd()">Hozzáadás</ion-button>
      </div>

      <div class="ikt-tabla-doboz">
        <table class="ikt-tabla">
          <thead><tr><th>Kinek</th><th>Hatókör</th><th>Szint</th><th class="szam">Mikortól</th><th></th></tr></thead>
          <tbody>
            <tr *ngFor="let j of jog.jogosultsagok">
              <td>{{ j.alany_nev || j.alany }}</td>
              <td>{{ j.hatokor }}</td>
              <td>{{ j.szint }}</td>
              <td class="szam">{{ j.letrehozva | date: 'yyyy. MM. dd.' }}</td>
              <td><ion-button size="small" fill="clear" color="danger" (click)="jogVon(j)">Visszavonás</ion-button></td>
            </tr>
          </tbody>
        </table>
        <div class="ikt-ures" *ngIf="!jog.jogosultsagok?.length">
          Nincs egyedi jogosultság – az alapértelmezés érvényes.
        </div>
      </div>
    </ng-container>
  </ion-card-content>
</ion-card>
